<template>
  <div>
    <div v-if="isIe" class="ie_main">
      <img src="@/assets/images/1.png" alt="" />
      <div>
        当前浏览器内核为兼容模式，无法正常显示，
        <br />
        参考图片，请点击网址输入框右边的符号，切换为极速模式
      </div>
    </div>
    <div v-else>
      <Header ref="header"></Header>
      <router-view></router-view>
      <Footer ref="footer"></Footer>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      isIe: false,
    };
  },
  mounted() {
    // this.isIe = this.getBrowser();
  },
  methods: {
    getBrowser() {
      function isIE() {
        return /MSIE|Trident/.test(window.navigator.userAgent);
      }
      return isIE();
    },
  },
};
</script>
<style lang="less">
.ie_main {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  padding-top: 80px;
  height: 100vh;
  font-size: 40px;
  line-height: 1.5;
}
</style>